<template>
  <el-card>
    <h3>销售业绩统计表</h3>
  </el-card>
</template>

<script>
export default {
  name: 'SalesPerformance'
}
</script>

<style scoped>

</style>
